import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

const StyInfoIcon = styled(InfoIcon, {
    name: 'StyInfoIcon',
})(() => ({
    verticalAlign: 'middle',
    marginLeft: '0px',
    marginBottom: '13.33px',
    height: '0.5em',
}));

type HeaderTooltipProps = {
    tooltip: string | number;
    colored: boolean;
    formattedValue: string;
    displayInfoIcon?: boolean;
    textAlign?: 'left' | 'right';
};

const formatDescriptionCell = (text: string, displayInfo: boolean) => {
    if (displayInfo) {
        return (
            <>
                <b>{text}</b>
                <StyInfoIcon>{text}</StyInfoIcon>
            </>
        );
    }

    return <b>{text}</b>;
};
const HeaderTooltip = ({
    tooltip,
    colored,
    formattedValue,
    displayInfoIcon = false,
    textAlign = 'right',
}: HeaderTooltipProps) => (
    <Tooltip title={tooltip}>
        {colored ? (
            <Box
                sx={{
                    color: 'primary.main',
                    textAlign,
                }}
            >
                {formatDescriptionCell(formattedValue, displayInfoIcon)}
            </Box>
        ) : (
            <Box sx={{ textAlign }}>{formattedValue}</Box>
        )}
    </Tooltip>
);

export default HeaderTooltip;
